export const IMMIGRATE_CATEGORY_CREATE_REQUEST = 'immigrate-category/create-request'
export const IMMIGRATE_CATEGORY_CREATE_SUCCESS = 'immigrate-category/create-success'
export const IMMIGRATE_CATEGORY_CREATE_FAILED = 'immigrate-category/create-failed'
